import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { Loading } from '@rd-web-markets/shared/dist/util';
const RecentClaimGroups = _ref => {
  let {
    claimGroups,
    recentClaimGroupIds,
    accountType
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const columns = [{
    text: ''
  }, {
    text: 'Accounting period'
  }, {
    text: 'Secured QE'
  }, {
    text: t('task_name')
  }, {
    text: t('projects')
  }, {
    text: t('in_progress')
  }, {
    text: t('costs_collected')
  }];
  if (!claimGroups) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }
  const getCurrentTask = claimGroup => {
    const task = claimGroup.tasks.find(task => task.status === 'in_progress');
    return task ? t(task.category_title) : t('not_started');
  };
  const getLastCompletedTaskTitle = claimGroup => {
    const allTasks = claimGroup.tasks.flatMap(task => task.tasks);
    const completedTasks = allTasks.filter(task => task.completed);
    if (completedTasks.length === 0) return null;
    return completedTasks[completedTasks.length - 1].title;
  };
  const rows = [];
  recentClaimGroupIds && claimGroups.length > 0 && recentClaimGroupIds.forEach(id => {
    const claimGroup = claimGroups.find(claimGroup => String(claimGroup.id) === id);
    if (claimGroup) {
      rows.push({
        accountingPeriod: claimGroup.claim_period,
        securedQe: claimGroup.total_rnd_amount,
        claimGroupData: [claimGroup.name, "".concat(location.pathname, "/companies/").concat(claimGroup.company_id, "/").concat(claimGroup.id, "/master")],
        activePhase: getCurrentTask(claimGroup),
        projects: claimGroup.projects_count,
        inProgress: claimGroup.in_progress_projects,
        costsCollected: claimGroup.cost_collected_projects,
        missionFrequency: claimGroup.current_prorata_revision_period,
        subtask: getLastCompletedTaskTitle(claimGroup)
      });
    }
  });
  const handleViewAllClaimGroups = () => {
    history.push("".concat(location.pathname, "/all_claim_groups?page=1&query="));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !recentClaimGroupIds ? /*#__PURE__*/React.createElement("p", {
    className: "text-center text-secondary"
  }, t('no_recent_claim_groups')) : /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    className: "recent-activity-table",
    style: {
      '--bs-table-striped-bg': 'transparent',
      '--bs-table-bg': 'transparent',
      '--bs-table-accent-bg': 'transparent'
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map((column, index) => {
    return /*#__PURE__*/React.createElement("th", {
      className: "text-center",
      key: index
    }, column.text);
  }))), /*#__PURE__*/React.createElement("tbody", null, rows.map((row, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: index,
      style: {
        background: 'transparent'
      }
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        background: 'transparent'
      }
    }, /*#__PURE__*/React.createElement(Link, {
      to: row.claimGroupData[1]
    }, row.claimGroupData[0])), /*#__PURE__*/React.createElement("td", {
      className: "text-center",
      style: {
        background: 'transparent'
      }
    }, row.accountingPeriod), /*#__PURE__*/React.createElement("td", {
      className: "text-center",
      style: {
        background: 'transparent'
      }
    }, row.securedQe), /*#__PURE__*/React.createElement("td", {
      className: "text-center",
      style: {
        background: 'transparent'
      }
    }, row.activePhase), /*#__PURE__*/React.createElement("td", {
      className: "text-center",
      style: {
        background: 'transparent'
      }
    }, row.projects), /*#__PURE__*/React.createElement("td", {
      className: "text-center",
      style: {
        background: 'transparent'
      }
    }, row.inProgress), /*#__PURE__*/React.createElement("td", {
      className: "text-center",
      style: {
        background: 'transparent'
      }
    }, row.costsCollected));
  }))), /*#__PURE__*/React.createElement("hr", null), accountType === 'admin' && /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleViewAllClaimGroups
  }, t('view_all_claim_groups')));
};
export default RecentClaimGroups;